import { render, staticRenderFns } from "./MetaDataNormalization.vue?vue&type=template&id=0ddefd98&scoped=true&"
import script from "./MetaDataNormalization.vue?vue&type=script&lang=js&"
export * from "./MetaDataNormalization.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataNormalization.vue?vue&type=style&index=0&id=0ddefd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddefd98",
  null
  
)

export default component.exports